import {
  patchState,
  signalStore,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { effect, inject } from '@angular/core';
import { BaseState, withCrudOperations } from '../crud.state';
import { Notification } from '../../models/notification';
import { withNotificationSelectors } from './notification.selectors';
import { withLogging } from '../features/logger.feature';
import { NotificationService } from '../../services/notification/notification.service';
import { hasOverlap } from '../../utility/array.utility';
import { ActiveUserStore } from '../user/active-user.state';

export type NotificationState = BaseState<Notification>;

export const initialState: NotificationState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Notification',
  entityLabel: 'Benachrichtigung',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const NotificationStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Notification>(NotificationService),
  withLogging(initialState.entityType),
  withNotificationSelectors(),
  withMethods(store => ({
    setActiveNotificationKey(key: string | undefined) {
      patchState(store, { selectedId: key });
    },
  })),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // See category.state.ts for why this watches commune reactively
      // instead of firing once at construction time.
      effect(
        () => {
          if (activeUserStore.commune()) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
